import React, { useState } from 'react';
import { HiComputerDesktop } from 'react-icons/hi2';
import { MdOutlinePeopleAlt } from 'react-icons/md'
import { FaHistory } from "react-icons/fa";
import Board from './Board';

const initialMove = [Array(9).fill(null)];

export default function TicTacToe() {
  const [isAutoPlay, setIsAutoPlay] = useState(true);
  const [isEasy, setIsEasy] = useState(true);
  const [history, setHistory] = useState(0);
  const [moves, setMoves] = useState(initialMove);

  function updateMoves (cells) {
    const preMoves = moves.slice();
    preMoves.push(cells);
    setMoves(preMoves);
    setHistory((pre) => pre+1);
  }

  function resetHistory() {
    console.log("from reset history ...");
    setHistory(0);
    setMoves(initialMove);
  }

  function showHistory(index){
    setHistory(index);
    setMoves(moves.slice(0, index+1));
  }
  return (
    <main className='main-container'>
      <section className='option-div'>
        <button
          className={`C-button${!isAutoPlay ? '-active' : ''}`}
          onClick={() => setIsAutoPlay(false)}
        >
          <MdOutlinePeopleAlt /> &nbsp;1 Vs 1 {!isAutoPlay && '✔'}
        </button>
        <button
          className={`C-button${isAutoPlay ? '-active' : ''}`}
          onClick={() => setIsAutoPlay(true)}
        >
          <HiComputerDesktop /> &nbsp; Computer {isAutoPlay && '✔'}
        </button>
        {isAutoPlay && (
          <div className='level'>
            <button
              style={{ backgroundColor: 'green' }}
              className='easy'
              onClick={() => {
                setIsEasy(true);
              }}
            >
              Easy {isEasy && '✔'}
            </button>
            <button
              style={{ backgroundColor: 'red' }}
              className='hard'
              onClick={() => {
                setIsEasy(false);
              }}
            >
              Hard {!isEasy && '✔'}
            </button>
          </div>
        )}
          <div className='history-container'>
            <h1 className='playerInfo' > <FaHistory />&nbsp; Jump To</h1> <br/>
            <div className="btn-history">
            { moves.map((move, index) =>
             {
               return (<button style={{backgroundColor : '#db6a84' }}
                 key={index}
                 onClick={() => showHistory(index)}>
                 # Go to {index === 0 ? 'start'  : index} move
                 </button>
               );
             })
            }
            </div>
          </div>
      </section>
      <Board
        isAutoPlay={isAutoPlay}
        currentMove={moves[history]}
        updateMoves={updateMoves}
        resetHistory={resetHistory}
        isEasy={isEasy}
      />
    </main>
  );
}
